import "./Title.scss"
const Title = ({ title }) => {
  return (
    <div className="section-title">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
      >
        <path
          d="M1.5 11.5981C-0.5 10.4434 -0.5 7.55662 1.5 6.40192L10.5 1.20577C12.5 0.0510705 15 1.49445 15 3.80385L15 14.1962C15 16.5056 12.5 17.9489 10.5 16.7942L1.5 11.5981Z"
          fill="#5D70B5"
        />
      </svg>

      {title}
    </div>
  );
};

export default Title;
